module.exports = __webpack_public_path__ + "img/162.b81b50ff.png";